<template>
    <div style="height: 100%; width: 100%;">
        <v-card class="rounded-0" style="z-index: 25;">
            <v-container class="pa-2">
                <v-row no-gutters align="center">

                    <v-col>
                        <!-- <FilterSearch /> -->
                    </v-col>

                    <v-col cols="auto">
                        <HoverMenu :width="'330px'" :nudgeamount="-3" :delay="100">
                            <template v-slot:menu-activator>
                                <v-btn icon small class="mx-2">
                                    <v-icon>
                                        mdi-map-marker
                                    </v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:menu-content>
                                <v-list class="py-0">
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t("servicesystem.common_objects.planner.show_markers_hint") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item-group v-model="MarkerStatusFilter" multiple>
                                        <v-list-item v-for="item in statuses" :key="item.Id" dense :value="item.Id"
                                            :color="item.Color">
                                            <v-list-item-icon>
                                                <v-icon v-text="item.Icon">
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.Name">
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </template>
                        </HoverMenu>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn icon small class="mx-2" @click="trigger++">
                            <v-icon>
                                mdi-cog
                            </v-icon>
                        </v-btn>
                        <MapOptionsDialog :mapOptions="mapOptions" :trigger="trigger">
                        </MapOptionsDialog>
                    </v-col>
                </v-row>

            </v-container>
        </v-card>

        <!-- marker loading progressbar -->
        <v-progress-linear v-if="loading" absolute indeterminate color="primary" style="z-index: 2000000;" height="3">
        </v-progress-linear>

        <!-- route loading overlay -->
        <v-overlay v-if="routeLoading" :absolute="true" :value="true" color="white">
            <div class="d-flex flex-column align-center justify-center pa-10"
                style="background: radial-gradient( rgba(255,255,255, 0.7) 40%, transparent 90%); border-radius: 4px;">
                <v-progress-circular size="50" width="3" indeterminate color="primary">
                </v-progress-circular>
                <h3 style="color: black" class="mt-3">Loading route...</h3>
            </div>
        </v-overlay>

        <!-- map and markers -->
        <Maps :options="mapOptions" :center="center" style="width: 100%; height: calc(100% - 44px);" :zoom="12"
            @idle_2="debounceIdle">

            <!-- main location marker -->
            <MapAdvMarker v-if="mainLocation" :position="mainLocation.location"
                :pinElementOptions="mainLocation.pinElementOptions" :title="mainLocation.title"
                :icon="mainLocation.icon">
            </MapAdvMarker>

            <!-- markers -->
            <MapAdvMarker :position="marker.location" v-for="marker in markers" :key="marker.id"
                :pinElementOptions="marker.pinElementOptions" :title="marker.title" :icon="marker.icon"
                @mouseenter="m => mouseover(m, marker)" @mouseleave="m => mouseleave(m, marker)"
                @click="m => click(m, marker)">
            </MapAdvMarker>

            <!-- if show route -->
            <template v-if="plan != null">
                <MapRoute v-for="(route) in plan.routes" :key="route.encodedPolyline" :path="route">
                </MapRoute>

                <MapAdvMarker :position="plan.origin" :pinElementOptions="{ glyphColor: '#FFFFFF' }"
                    icon="mdi mdi-flag-checkered">
                </MapAdvMarker>

                <MapAdvMarker v-for="(route, index) in plan.routes" :key="'_' + route.encodedPolyline"
                    :position="route.endLocation" :pinElementOptions="{ glyphColor: '#FFFFFF' }"
                    :icon="`mdi mdi-numeric-${index + 1}`">
                </MapAdvMarker>
            </template>

        </Maps>
    </div>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import MapOptionsDialog from '@/components/Dialogs/MapOptionsDialog.vue';
import { debounce } from "debounce";
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
    name: "PlannerMaps",
    props: {
        center: {
            type: Object,
            default: () => { return { lng: 10.7522, lat: 59.9139 } }
        },
        mainLocationCoordinates: Object,
        routeData: Object
    },
    components: {
        MapOptionsDialog,
        HoverMenu,
    },

    data() {
        return {
            markers: [],
            mainLocation: null,
            plan: null,
            jobIds: [],
            loading: false,
            lastMarkerSetJson: null,
            lastIdleEvent: null,
            routeLoading: false,
            trigger: 1,
        }
    },

    mounted() {
        this.getMainLocation();
        this.getRouteData();
        this.subscribe();
        ClientAPIMixin.methods.mapsInit().then(() => {
            this.refreshMarkers();
        });
    },

    beforeDestroy() {
        this.unSubscribe();
    },

    methods: {
        //tiny debounce just to not trigger tons of api requests on hotkey usage
        debounceIdle: debounce(function (obj) {
            this.handleIdle(obj);
        }, 700),

        subscribe() {
            this.$store.dispatch("NotificationStore/subscribe", [SRConst.EventKeys.JobChange, this.debounceRefresh]);
        },
        unSubscribe() {
            this.$store.dispatch("NotificationStore/unsubscribe", [SRConst.EventKeys.JobChange, this.debounceRefresh]);
        },

        //debounce to avoid to many refreshes triggered by filter/menu changes
        debounceRefresh: debounce(function () {
            //console.log('debounceRefresh');
            this.refreshMarkers();
        }, 700),

        refreshMarkers() {
            if (this.lastIdleEvent) {
                //console.log('refreshMarkers', this.lastIdleEvent);
                this.getNearbyJobs(this.lastIdleEvent.center, this.lastIdleEvent.radius);
            }
        },

        handleIdle(obj) {
            //console.log('handleIdle', obj);
            this.lastIdleEvent = obj;
            this.getNearbyJobs(obj.center, obj.radius);
        },

        getNearbyJobs(center, radius) {
            this.loading = true;
            const dto = {
                Origin: {
                    Longitude: center.lng,
                    Latitude: center.lat
                },
                Radius: radius * 1.25, //extra leeway to load markers quicker on small zoom changes
                JobListFilter: {
                    JobStatusIdList: this.MarkerStatusFilter,
                },
            }
            ClientAPIMixin.methods.getNearbyJobs(dto)
                .then(response => {
                    //console.log('getNearbyJobs', response)

                    //skip if no changes to markers
                    if (this.lastMarkerSetJson != JSON.stringify(response)) {
                        this.markers = response.map(item => {
                            //stable id that will cause marker to re-render only if anything inside the entry changes
                            var refreshTriggerId = JSON.stringify(item);
                            var count = item.Jobs.length;
                            var tiptext = count > 1 ? 'Multiple jobs' : item.Jobs[0].DisplayName;
                            var marker =
                            {
                                id: refreshTriggerId,
                                jobs: item.Jobs,
                                location: { lng: item.GeoLocation?.Longitude, lat: item.GeoLocation?.Latitude },
                                title: tiptext,
                            }
                            this.setMarkerStyle(marker);
                            return marker;
                        })
                        //console.log('markers', this.markers);
                        this.lastMarkerSetJson = JSON.stringify(response);
                    }
                    this.loading = false;
                    this.highlightMarkers();
                })

        },

        highlightMarkers() {
            const hoveredJob = this.jobList.find(j => j.hover == true)
            const selectedJob = this.jobList.find(j => j.selected == true)

            this.markers.forEach(marker => {
                const wasHovered = marker.hover;
                const isHovered = hoveredJob && marker.jobs.find(j => j.Id == hoveredJob.Id);   //true if any job is hovered and that job is in this location
                marker.hover = isHovered;

                const wasSelected = marker.selected;
                const isSelected = selectedJob && marker.jobs.find(j => j.Id == selectedJob.Id);     //true if any job is selected and that job is in this location
                marker.selected = isSelected;

                //only re-render if hover or selected state has changed
                if (wasHovered != isHovered || wasSelected != isSelected) {
                    console.log('target changed', marker);
                    this.setMarkerStyle(marker);
                }
            });
        },

        getMainLocation() {
            if (this.mainLocationCoordinates) {
                this.mainLocation = {
                    id: 0,
                    location: this.center,
                    title: "Main office",
                    pinElementOptions: {
                        background: 'black',
                        borderColor: 'white',
                        glyphColor: 'white',
                        scale: 1.5
                    },
                    icon: "mdi mdi-home",
                    label: "H"
                }
            }
        },

        schedulerChange() {
            this.getRouteData()
        },

        mouseover(arg, item) {
            const jobIds = item.jobs.map(e => e.Id);
            this.jobList.forEach(j => {
                j.hover = jobIds.includes(j.Id)
            })
        },

        mouseleave() {
            this.jobList.forEach(j => {
                j.hover = false
            })
        },

        click(m, item) {
            const jobIds = item.jobs.map(e => e.Id);
            this.jobList.forEach(j => {
                j.selected = jobIds.includes(j.Id)
            })
        },

        getRouteData() {
            this.plan = null;
            if (this.routeData && this.routeData.userId) {
                this.routeLoading = true;
                ClientAPIMixin.methods.getRouteData(this.routeData.userId, this.routeData.date)
                    .then(response => {
                        this.plan = response;
                    }).catch(error => {
                        console.error('Error fetching route data:', error);
                    }).finally(() => {
                        this.routeLoading = false;
                    });
            }
            else {
                this.plan = null
            }
        },

        setMarkerStyle(marker) {
            //const hoverColor = window.getComputedStyle(document.body).getPropertyValue('--v-primary-lighten1');
            //const hoverColorBackground = window.getComputedStyle(document.body).getPropertyValue('--v-primary-base');
            //const hoverColorBorder = window.getComputedStyle(document.body).getPropertyValue('--v-primary-darken1');
            //const selectedColor = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-lighten1');
            
            //const selectedColorBackground = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-base');
            //const selectedColorBorder = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-darken1');

            const count = marker.jobs.length;
            const icon = count > 1 ? `mdi mdi-numeric-${count > 9 ? '9-plus' : count}` : '';

            var statusColor = this.statuscolor(marker.jobs[0].JobStatusId)
            marker.pinElementOptions = {
                glyphColor: count > 1 ? 'white' : 'rgba(0, 0, 0, 0.1)',
                background: /*marker.selected ? selectedColorBackground : marker.hover ? hoverColorBackground :*/ statusColor,
                borderColor: /*marker.selected ? selectedColorBorder : marker.hover ? '#797979' :*/ statusColor,
                scale: marker.hover ? 1.5 : marker.selected ? 1.2 : 0.9
            }
            marker.icon = icon;
            //console.log('marker', count, marker);
        },
    },

    computed: {
        statuses() {
            var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
            var filteredstatuses = statuses.filter((y) => y.Id < 70);
            return filteredstatuses;
        },
        defaultStatuses() {
            return this.statuses.filter(s => s.Id < 50).map(x => x.Id);
        },

        MarkerStatusFilter: {
            get() {
                var stored = this.$store.getters["prefrences/Prefrence"]("PlannerMarkerStatusFilter");
                if (stored && stored.length) {
                    return stored;
                }
                else {
                    return this.defaultStatuses;
                }
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerMarkerStatusFilter", value: update });
                this.debounceRefresh()
            },
        },

        jobList() {
            return this.$store.getters["plannerstore/UnplannedJobList"];
        },

        mapOptions: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerMapOptions");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerMapOptions", value: update });
            },
        },
    },
}
</script>
